import { logError } from "../utils/errorHandlingUtils"
import { firebaseFetch} from "../utils/firebase"

export const SAVE_SETTLEMENTS = 'SAVE_SETTLEMENTS'

export const saveSettlements = (settlements=[]) => {
    return {
        type: SAVE_SETTLEMENTS,
        payload: {
            settlements
        }
    }
}

export const httpFetchSaveSettlement = (
    settlementId="",
    onSuccess = () => {
    },
    onError = () => {
    }
) => {
    if (!settlementId) return false
    return async dispatch => {
        try {

            const settlement = await firebaseFetch(
                "settlements", 
                settlementId,
            )
            if (settlement) {
                dispatch(saveSettlements([settlement]))
            } else throw new Error(`Settlement does not exist ${settlementId}`)
            onSuccess(settlementId)
            return true
        } catch (e) {
            const message = `action > settlements > httpFetchSaveSettlement: Failed to save settlement ${settlementId}`
            if (e.message_) {
                //deal with firebase-specific errors
                logError(new Error(`${e.message} ${message}`))
            } else {
                e.message = `${e.message} ${message}`
                logError(e)
            }
            onError(settlementId)
            return false
        }
    }
}